/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@spotahome/ui-library';

import { capitalizeFirstLetter } from '@spotahome/marketplace-common/src/utils/stringUtils';

const Crumb = ({ href, label, position }) => (
  <span
    itemProp="itemListElement"
    itemScope
    itemType="https://schema.org/ListItem"
  >
    {href ? (
      <Link itemProp="item" href={href} className="ga-detail-breadcrumb">
        <span itemProp="name">{capitalizeFirstLetter(label)}</span>
        <meta itemProp="position" content={position} />
      </Link>
    ) : (
      <span>
        <span itemProp="name">{capitalizeFirstLetter(label)}</span>
        <meta itemProp="position" content={position} />
      </span>
    )}
  </span>
);

Crumb.propTypes = {
  label: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  href: PropTypes.string
};

Crumb.defaultProps = {
  href: ''
};

export default Crumb;
